<div class="products-grid" fxFlex="100" fxLayout="column">
  <div *ngIf="title != null || count != null" class="products-grid__header" fxLayout="row" fxLayoutAlign="start center">
    <h5 *ngIf="title != null" class="products-grid__header__title">
      {{ title | translate }}
    </h5>
    <span *ngIf="count != null" class="products-grid__header__count">‚
      {{ 'PRODUCTS_GRID.PRODUCT' | translate: {count: count} }}
    </span>
  </div>
  <div *ngIf="products !== null"
       [mmTestId]="testId || 'PRODUCTS_GRID.LIST'"
       class="products-grid__list">

    <div [ngClass]="{'gutter16':  isNewPLPVariantRestyle && isPLP && !isMobile, gutter8: (isNewPLPVariantRestyle) && isPLP && isMobile}"
         class="products-grid__list__row"
         fxLayout="row wrap" fxLayout.mm-mobile="column">
      <ng-container *ngFor="let product of products; trackBy: trackById; let i=index">
        <div (isVisible)="onProductVisibilityChange($event, i)"
             [keepMeTracked]="true"
             [ngClass]="{'products-grid__list__row__colWithGutter': isNewPLPVariantRestyle && isPLP,'border-none': isNewPLPVariantRestyle && isPLP}" appIsVisible class="products-grid__list__row__col">
          <app-search-product-card-variants (productClick)="onProductClick($event.product, $event.priceType, i)"
                                            *ngIf="isNewPLPVariantRestyle; else currentCardDesign"
                                            [addToCartConfig]="addToCartConfig"
                                            [isBlackDealsEnabled]="(isBlackDealsEnabled$ | async)"
                                            [isCustomPLPPage]="isCustomPLPPage"
                                            [isDesktop]="isDesktop"
                                            [isMobileOrTablet]="!isDesktop"
                                            [isSimilarProductRecommendation]="recommendation"
                                            [productIndex]="i"
                                            [product]="product"
                                            [saveTotalUnitsOrBasePriceSpace]="!isMobile ? rowHasTotalUnitsOrBasePrice(i,isDesktop) : null"
                                            [shouldSaveSpaceForAddToCart]="!isMobile ? someOtherRowProductHasAddToCart(i) : null"
                                            [shouldSaveSpaceForVariants]="!isMobile ? someOtherRowProductHasVariants(i, isDesktop) : null"
                                            class="products-grid__list__row__col__card">
          </app-search-product-card-variants>
          <ng-template #currentCardDesign>
            <app-search-product-card (productClick)="onProductClick($event.product, $event.priceType, i)"
                                     [isBlackDealsEnabled]="(isBlackDealsEnabled$ | async)"
                                     [isCustomPLPPage]="isCustomPLPPage"
                                     [isDesktop]="isDesktop"
                                     [isSimilarProductRecommendation]="recommendation"
                                     [product]="product"
                                     class="products-grid__list__row__col__card">
            </app-search-product-card>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </div>
</div>
